const logout = () => {
    localStorage.clear();
    window.location.reload();
};

export { logout };



// WEBPACK FOOTER //
// ./src/utils/auth.ts